import clickOutside from 'click-outside';

const initDropButtons = () => {
  const dropMenuButtons = document.querySelectorAll('.drop-menu');
  dropMenuButtons.forEach((dropMenuButton) => {
    if (!dropMenuButton.classList.contains('_init')) {
      dropMenuButton.addEventListener('click', () => {
        dropMenuButton.parentNode.classList.toggle('drop-menu-active');
      });
      clickOutside(dropMenuButton.parentNode, () => {
        dropMenuButton.parentNode.classList.remove('drop-menu-active');
      });

      dropMenuButton.classList.add('_init');
    }
  });
};

initDropButtons();

window.initDropMenuButtons = initDropButtons;
